export default "__VITE_ASSET__B84oq4rj__"